module.exports = {
  "widget.head": "Sin pago inicial, paga en quincenas",
  "widget.simulation-1": "Pago mínimo quincenal",
  "widget.simulation-2": "Monto de la compra",
  "widget.simulation-3": "Plazo máximo de pago",
  "widget.simulation-3.1": "quincenas",
  "widget.simulation-4":
    "Pago mínimo quincenal calculado para fines informativos y de comparación. Cálculo realizado considerando el monto de la compra, un plazo de 60 quincenas y una tasa de interés anual del 35.9% (sin IVA).",
  "widget.features-1": "Completa tu solicitud sin esfuerzo y ¡en minutos!",
  "widget.features-2":
    "Cuentas con 30 días para pagar el total de tu préstamo con 0% de interés",
  "widget.features-3":
    "Paga fácilmente con tu tarjeta de débito en cómodas quincenas",
  "widget.security":
    "Creditea y sus socios garantizan la seguridad del proceso.",
  "widget.footer-1": "Compra con crédito sin pago inicial",
  "widget.footer-2": "¡No necesitas una tarjeta de crédito!",
  "widget.footer-3":
    "Creditea es una empresa de préstamos personales en línea que pertenece a uno de los grupos financieros líderes en el mundo: International Personal Finance PLC. Actualmente ayudamos a más de 2.8 millones de personas, y con IPF Digital tenemos presencia en 9 países.",
  "creditea-pay-introduction.head-1":
    "¡Gracias por elegir Creditea como tu medio de pago!",
  "creditea-pay-introduction.simulation-1":
    "Para obtener tu crédito vas a necesitar:",
  "creditea-pay-introduction.simulation-3": "CURP",
  "creditea-pay-introduction.simulation-4": "Número de teléfono",
  "creditea-pay-introduction.simulation-5": "Tarjeta débito",
  "creditea-pay-introduction.simulation-6": "Identificación",
  "creditea-pay-introduction.simulation-7":
    "Si eres un cliente existente solo necesitarás CURP y número de teléfono.",
  "creditea-pay-introduction.simulation-8": "He leído y acepto los",
  "creditea-pay-introduction.simulation-8.1":
    "términos y condiciones de uso de la página web",
  "creditea-pay-introduction.simulation-details-1": "Monto de la compra",
  "creditea-pay-introduction.simulation-details-2": "Pago mínimo quincenal",
  "creditea-pay-introduction.simulation-details-3":
    "*Pago mínimo quincenal calculado para fines informativos y de comparación. Cálculo realizado considerando el monto de la compra, un plazo de 60 quincenas y una tasa de interés anual del 35.9% (sin IVA).",
  "creditea-pay-introduction.simulation-details-4":
    "La oferta final será otorgada en función de tu perfil crediticio y nuestras políticas internas.",
  "creditea-pay-introduction.simulation-details-5":
    "Comprar con Creditea te da la oportunidad de obtener una Línea de Crédito de hasta $70,000 pesos",
  "creditea-pay-introduction.next-step": "Es muy fácil:",
  "creditea-pay-introduction.next-step-1": "Completa tus datos:",
  "creditea-pay-introduction.next-step-1.1":
    "Proporciona tus datos para poder darte una oferta de crédito.",
  "creditea-pay-introduction.next-step-2": "Acepta tu oferta de crédito:",
  "creditea-pay-introduction.next-step-2.1":
    "Podrás obtener una línea de crédito de hasta $70.000 para esta y tus siguientes compras.",
  "creditea-pay-introduction.next-step-3": "Finaliza tu compra:",
  "creditea-pay-introduction.next-step-3.1":
    "Termina el proceso y disfruta tu compra.",
  "creditea-pay-introduction.security":
    "Creditea y sus socios garantizan la seguridad del proceso.",
  "creditea-pay-introduction.cta": "Continuar",
  "customer-data-basic.title": "Datos del cliente (Básico)",
  "customer-data-basic.curp": "CURP",
  "customer-data-basic.phone-number": "Número de teléfono",
  "customer-data-basic.name": "Nombre",
  "customer-data-basic.surname": "Apellido",
  "customer-data-basic.accept": "Acepto que se procesen mis datos",
  "customer-data-basic.cta-existing-customer": "Cliente existente",
  "customer-data-basic.cta-new-customer": "Cliente nuevo",
  "otp-check.title": "Verificación de OTP",
  "otp-check.description":
    "Se te ha enviado un código de verificación. Por favor, introdúcelo a continuación.",
  "otp-check.code": "Código",
  "otp-check.cta-authenticated-positive": "Autenticado positivo",
  "otp-check.cta-authenticated-negative": "Autenticado negativo",
  "otp-check.cta-not-authenticated": "No autenticado",
  "wrong-data-rejection.title": "Rechazo de datos incorrectos",
  "wrong-data-rejection.description": "El código introducido no es correcto.",
  "wrong-data-rejection.cta-resend-code": "Reenviar código",
  "wrong-data-rejection.cta-provide-data-again": "Volver a introducir datos",
  "wrong-data-rejection.description-too-many-attempts":
    "Se ha superado el número máximo de intentos. Por favor, espera 15 minutos antes de volver a intentarlo.",
  "wrong-data-rejection.cta-too-many-attempts": "Demasiados intentos",
  "negative-draw-simulation.title": "Simulación de retiro negativo",
  "negative-draw-simulation.description": "Límite de crédito insuficiente.",
  "negative-draw-simulation.cta": "Regresar a la tienda",
  "draw-simulation.title": "Simulación de retiro",
  "draw-simulation.description":
    "El límite de crédito es suficiente para hacer la compra.",
  "draw-simulation.credit-limit": "Límite de crédito",
  "draw-simulation.purchase-amount": "Monto de compra",
  "draw-simulation.payment-plan": "Plan de pagos",
  "draw-simulation.cta-success": "Compra exitosa",
  "draw-simulation.cta-error": "Compra fallida",
  "sorry-page.title": "Página de error",
  "sorry-page.description":
    "Ocurrió un error y la compra no pudo ser procesada. Pongase en contacto con el servicio de atención al cliente.",
  "sorry-page.phone": "Teléfono",
  "sorry-page.email": "Correo electrónico",
  "success-page.title": "Página de éxito",
  "success-page.description":
    "La compra se ha realizado con éxito. Recibirás un correo electrónico con los detalles de la compra.",
  "customer-data-detailed.title": "Datos del cliente (Detallado)",
  "customer-data-detailed.address": "Dirección",
  "customer-data-detailed.email": "Correo electrónico",
  "customer-data-detailed.income": "Ingresos",
  "customer-data-detailed.cta": "Enviar",
  "application-confirmation.title": "Confirmación de solicitud",
  "application-confirmation.description":
    "Se ha enviado un código de verificación. Al poner el código y dar click en aceptar, doy mi consentimiento para que mis datos sean verificados por el Buró de Crédito y acepto las políticas de privacidad de Creditea.",
  "application-confirmation.code": "Código",
  "application-confirmation.cta-authenticated-positive": "Autenticado positivo",
  "application-confirmation.cta-authenticated-negative": "Autenticado negativo",
  "application-confirmation.cta-not-authenticated": "No autenticado",
  "offer-available.title": "Oferta disponible",
  "offer-available.description": "Tenemos una oferta disponible para ti.",
  "offer-available.credit-limit": "Límite de crédito",
  "offer-available.purchase-amount": "Monto de compra",
  "offer-available.payment-plan": "Plan de pagos",
  "offer-available.cta": "Aceptar",
  "contract-terms.title": "Términos del contrato",
  "contract-terms.description":
    "Por favor, lea cuidadosamente los términos del contrato antes de aceptar.",
  "contract-terms.cta": "Aceptar",
  "debit-card-registration.title": "Registro de tarjeta de débito",
  "debit-card-registration.description":
    "Para continuar, necesitamos que registres una tarjeta de débito.",
  "debit-card-registration.description-loading": "Redirigiendo...",
  "debit-card-registration.cta-no-income-verification":
    "Sin verificación de ingresos",
  "debit-card-registration.cta-income-verification":
    "Requiere verificación de ingresos",
  "debit-card-registration-form.description-registered": "Registrado",
  "debit-card-registration-form.cta-card-number": "Número de tarjeta",
  "debit-card-registration-form.cta": "Enviar",
  "onfido-identification.title": "Identificación de Onfido",
  "onfido-identification.description":
    "Para continuar usa Onfido para identificarte.",
  "onfido-identification.description-loading": "Redirigiendo...",
  "onfido-identification-form.title": "Widget de Onfido",
  "onfido-identification.cta": "Completado",
  "waiting-page.title": "Página de espera",
  "waiting-page.description":
    "Por favor, espere. Estamos validando sus datos, esto podría demorar algunos minutos.",
  "waiting-page.cta-success": "Éxito",
  "waiting-page.cta-onfido-failed": "Onfido fallido",
  "validations.accept-terms-required":
    "Debes aceptar los términos y condiciones",
  "validations.promotion-code-invalid": "Escribe un código válido",
  "validations.curp-required": "El CURP es obligatorio",
  "validations.curp-invalid": "El CURP es inválido",
  "validations.phone-number-required": "El número de teléfono es obligatorio",
  "validations.phone-number-invalid": "El número de teléfono es inválido",
  "validations.accept-privacy-policy-required":
    "Debes aceptar la política de privacidad",
  "validations.name-required": "El nombre es obligatorio",
  "validations.surname-required": "El apellido es obligatorio",
  "validations.accept-required": "Debes aceptar que se procesen tus datos",
  "validations.address-required": "La dirección es obligatoria",
  "validations.email-required": "El correo electrónico es obligatorio",
  "validations.email-invalid": "El correo electrónico es inválido",
  "validations.income-required": "Los ingresos son obligatorios",
  "validations.code-required":
    "El código que ingresaste es incorrecto o inválido",
};
